export const frontPortfolio = [
  {
    id: 1,
    title: "projeto Trybewarts",
    img: "assets/trybewarts.png",
    link: "https://github.com/thisouzadev/fundamentos-projeto-trybewarts",
  },

  {
    id: 2,
    title: "Todo list",
    img: "assets/todo-list.png",
    link: "https://github.com/thisouzadev/fundamentos-todo-list",
  },
  {
    id: 3,
    title: " Movie Cards CRUD",
    img: "assets/movie-cards-crud.png",
    link: "https://github.com/thisouzadev/front-end-movie-card-library-crud",
  },
  {
    id: 4,
    title: "Trivia!",
    img: "assets/trivia.png",
    link: "https://github.com/thisouzadev/front-end-trivia-react-redux",
  },
  {
    id: 5,
    title: "Starwars Planets Search",
    img: "assets/starwars-planets-search.png",
    link: "https://github.com/thisouzadev/front-end-starwars-planets-search",
  },
  {
    id: 6,
    title: "projeto de Receitas!",
    img: "assets/receitas.png",
    link: "https://github.com/thisouzadev/front-end-project-recipes-app",
  },
];

export const backPortfolio = [
  {
    id: 1,
    title: "projeto Cookmaster!",
    img: "assets/chief-cook.png",
    link: "https://github.com/thisouzadev/back-end-cookmaster",
  },
  {
    id: 2,
    title: "API de Blogs!",
    img: "assets/api-blogs.png",
    link: "https://github.com/thisouzadev/back-end-blogs-api",
  },
  {
    id: 3,
    title: "Talker Manager!",
    img: "assets/talker-manager.png",
    link: "https://github.com/thisouzadev/back-end-project-talker-manager",
  },
  {
    id: 4,
    title: "Aggregations!",
    img: "assets/mongodb.png",
    link: "https://github.com/thisouzadev/back-end-mongodb-aggregations",
  },
  {
    id: 5,
    title: "projeto One For All!",
    img: "assets/mysql.png",
    link: "https://github.com/thisouzadev/back-end-mysql-one-for-all",
  },
];

export const pythonPortfolio = [
  {
    id: 1,
    title: "Tech News!",
    img: "assets/tech-news.png",
    link: "https://github.com/thisouzadev/ciencia-da-computacao-tech-news",
  },
  {
    id: 2,
    title: "Restaurant Orders!",
    img: "assets/restaurant-orders.png",
    link: "https://github.com/thisouzadev/ciencia-da-computacao-restaurant-orders",
  },
  {
    id: 3,
    title: "TING(Trybe is not Google)!",
    img: "assets/ting.png",
    link: "https://github.com/thisouzadev/-ciencia-da-computacao-project-ting",
  },
  {
    id: 4,
    title: "Job Insights!",
    img: "assets/python.png",
    link: "https://github.com/thisouzadev/ciencia-da-computacao-job-insights",
  },
  {
    id: 5,
    title: "projeto de Algorithms!",
    img: "assets/python.png",
    link: "https://github.com/thisouzadev/ciencia-da-computacao-project-algorithms",
  },
  {
    id: 6,
    title: "Relatório de Estoque!",
    img: "assets/estoque.png",
    link: "https://github.com/thisouzadev/ciencia-da-computacao-inventory-report",
  },
];
